/**
 * Wheel zoom on the big map is armed only while the primary button is held
 * on the map itself. A press on the sidebar, filters, or +/- control must
 * not arm it, or that press would steal the page scroll.
 */
export const pointerArmsMapWheelZoom = (button: number, onChrome: boolean): boolean =>
  button === 0 && !onChrome;

/** Sidebar, filters, and Mapbox's zoom control. */
export const MAP_WHEEL_ZOOM_CHROME = "[data-map-chrome], .mapboxgl-ctrl";
